<template>
    <div class="placeholder">
        <div class="flex flex-wrap justify-center mb-3 sm:mb-6">
            <div class="w-full">
                <div class="mb-5 sm:mb-3 text-center">
                    <div class="heading m-0"></div>
                </div>

                <div class="flex flex-wrap items-center justify-center mb-3 sm:mb-6">
                    <category-loader v-for="index in 12" :key="index" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
.placeholder {
    @apply relative flex flex-col items-center;
}

.placeholder .heading {
    @apply text-center w-56 h-8 flex flex-col items-center;
    margin: 0 auto;
}

// .placeholder,
.placeholder .heading,
.placeholder:after,
.placeholder:before {
    /* bg-gray-300 */
    background-color: #e3e7ed;
    animation-duration: 0.8s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: shimmer;
    animation-timing-function: linear;
    background-size: 800px 10px;
    background-image: linear-gradient(90deg,#e3e7ed 8%,#cdd4e0 18%,#e3e7ed 33%);
}
</style>
